export default __webpack_public_path__ + "static/media/VAN.3780e530.svg";